import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import Resx from '@/components/Resx'
import { Link } from 'react-router-dom'
import Name from '@/components/Name'

const BlacklistRecordLinks = ({ records = [] }) => {
  return (records || []).map((x, idx) => <React.Fragment key={idx}>
    {idx > 0 ? <span className='mr-1'>,</span> : null}
    <Link className='individual-detail-link' to={`/blacklists/${x.id}`}><Name data={x} /></Link>
  </React.Fragment>)
}
export default class DataCrossingsIndividualDetail extends Component {
  static propTypes = {
    individual: PropTypes.object.isRequired,
    normalizedIndividual: PropTypes.object,
    localize: PropTypes.any.isRequired,
    onNavigate: PropTypes.func
  }

  render () {
    const { individual, normalizedIndividual, localize, onNavigate } = this.props

    return (
      <React.Fragment>
        <InfoRow>
          <InfoLabel><Resx name='Individuals.Name' /></InfoLabel>
          <InfoContent>{individual.firstName} {normalizedIndividual && normalizedIndividual.firstName && `(${localize('DataCrossings.Normalized')} ${normalizedIndividual.firstName})`}</InfoContent>
        </InfoRow>
        <InfoRow>
          <InfoLabel><Resx name='Individuals.Surname' /></InfoLabel>
          <InfoContent>{individual.surname} {normalizedIndividual && normalizedIndividual.surname && `(${localize('DataCrossings.Normalized')} ${normalizedIndividual.surname})`}</InfoContent>
        </InfoRow>
        <InfoRow>
          <InfoLabel><Resx name='Individuals.FatherName' /></InfoLabel>
          <InfoContent>{individual.fatherName} {normalizedIndividual && normalizedIndividual.fatherName && `(${localize('DataCrossings.Normalized')} ${normalizedIndividual.fatherName})`}</InfoContent>
        </InfoRow>
        <InfoRow>
          <InfoLabel><Resx name='Individuals.MotherName' /></InfoLabel>
          <InfoContent>{individual.motherName}</InfoContent>
        </InfoRow>
        <InfoRow>
          <InfoLabel><Resx name='Individuals.GrandfatherName' /></InfoLabel>
          <InfoContent>{individual.grandfatherName} {normalizedIndividual && normalizedIndividual.grandfatherName && `(${localize('DataCrossings.Normalized')} ${normalizedIndividual.grandfatherName})`}</InfoContent>
        </InfoRow>
        <InfoRow>
          <InfoLabel><Resx name='Individuals.MotherFatherName' /></InfoLabel>
          <InfoContent>{individual.motherFatherName}</InfoContent>
        </InfoRow>
        <InfoRow>
          <InfoLabel><Resx name='Individuals.GreatGrandfatherName' /></InfoLabel>
          <InfoContent>{individual.greatGrandfatherName} {normalizedIndividual && normalizedIndividual.greatGrandfatherName && `(${localize('DataCrossings.Normalized')} ${normalizedIndividual.greatGrandfatherName})`}</InfoContent>
        </InfoRow>
        <InfoRow>
          <InfoLabel><Resx name='Individuals.MotherGrandfatherName' /></InfoLabel>
          <InfoContent>{individual.motherGrandfatherName}</InfoContent>
        </InfoRow>
        <InfoRow>
          <InfoLabel><Resx name='Individuals.BirthDate' /></InfoLabel>
          <InfoContent>{new Date(individual.birthDate).toLocaleDateString()}</InfoContent>
        </InfoRow>
        <InfoRow>
          <InfoLabel><Resx name='Individuals.Nationality' /></InfoLabel>
          <InfoContent><Name data={individual.nationality} /></InfoContent>
        </InfoRow>
        <InfoRow>
          <InfoLabel><Resx name='Blacklists.ValidBlacklistRecords' /></InfoLabel>
          <InfoContent><BlacklistRecordLinks records={individual.validBlacklistRecords} /></InfoContent>
        </InfoRow>
        <InfoRow>
          <InfoLabel><Resx name='Blacklists.PastBlacklistRecords' /></InfoLabel>
          <InfoContent><BlacklistRecordLinks records={individual.pastBlacklistRecords} /></InfoContent>
        </InfoRow>
        <InfoRow>
          <InfoLabel />
          <InfoContent>
            <Link className='individual-detail-link' onClick={() => {
              if (typeof onNavigate === 'function') onNavigate()
            }
            } to={`/individuals/${individual.id}`}>
              <Resx name='DataCrossings.ShowIndividualDetail' />
            </Link>
          </InfoContent>
        </InfoRow>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/dataCrossing/individual-detail.js